import React from "react";
import { Button, Box, Typography } from "@mui/material";
import moment from "moment";
import emitter from "tiny-emitter/instance";
import { getMediaTypeColor } from "./chartColors";

export default function LegendComponent(props) {
	const [filters, setFilters] = React.useState([]);

	const [currentDataTotal, setCurrentDataTotal] = React.useState({
		television: 0,
		radio: 0,
		online: 0,
		newspaper: 0,
		magazine: 0,
		outdoor: 0,
		mobile: 0,
		podcast: 0,
		print: 0,
		advertorial: 0,
		directmarketing: 0,
		socialmedia: 0,
	});
	const [previousDataTotal, setPreviousDataTotal] = React.useState({
		television: 0,
		radio: 0,
		online: 0,
		newspaper: 0,
		magazine: 0,
		outdoor: 0,
		mobile: 0,
		podcast: 0,
		print: 0,
		advertorial: 0,
		directmarketing: 0,
		socialmedia: 0,
	});
	const [itemValue, setItemValue] = React.useState({
		television: 0,
		radio: 0,
		online: 0,
		newspaper: 0,
		magazine: 0,
		outdoor: 0,
		mobile: 0,
		podcast: 0,
		print: 0,
		advertorial: 0,
		directmarketing: 0,
		socialmedia: 0,
	});
	const [previousItemValue, setPreviousItemValue] = React.useState({
		television: 0,
		radio: 0,
		online: 0,
		newspaper: 0,
		magazine: 0,
		outdoor: 0,
		mobile: 0,
		podcast: 0,
		print: 0,
		advertorial: 0,
		directmarketing: 0,
		socialmedia: 0,
	});
	const [zoomMediaTypes, setZoomMediaTypes] = React.useState(null);
	const [, setVolumeToggleVersion] = React.useState(0);

	let pressed = React.useRef([]);
	React.useEffect(() => {
		if (["/mediaType", "/volume"].includes(props.route?.pathname)) {
			setFilters([
				{
					title: "television",
					icon: (
						<svg
							width="25"
							height="25"
							viewBox="0 0 25 25"
							fill="none"
							xmlns="http://www.w3.org/2000/svg"
						>
							<circle
								opacity="0.05"
								cx="12.5"
								cy="12.5"
								r="12.5"
								fill="#3966D0"
							/>
							<path
								d="M7.30957 15.6533H17.6855C18.5205 15.6533 18.9404 15.2529 18.9404 14.3984V8.80273C18.9404 7.94824 18.5205 7.54785 17.6855 7.54785H7.30957C6.47461 7.54785 6.05469 7.94824 6.05469 8.80273V14.3984C6.05469 15.2529 6.47461 15.6533 7.30957 15.6533ZM7.32422 14.8672C6.9873 14.8672 6.84082 14.7305 6.84082 14.3887V8.81738C6.84082 8.4707 6.9873 8.33398 7.32422 8.33398H17.6709C18.0078 8.33398 18.1543 8.4707 18.1543 8.81738V14.3887C18.1543 14.7305 18.0078 14.8672 17.6709 14.8672H7.32422ZM16.0449 17.0107C16.0449 16.7568 15.8447 16.5518 15.5957 16.5518H9.38965C9.14062 16.5518 8.93555 16.7568 8.93555 17.0107C8.93555 17.2646 9.14062 17.4697 9.38965 17.4697H15.5957C15.8447 17.4697 16.0449 17.2646 16.0449 17.0107Z"
								fill="#3966D0"
							/>
						</svg>
					),
					items: 0,
					increase: 0,
				},
				{
					title: "radio",
					icon: (
						<svg
							width="25"
							height="25"
							viewBox="0 0 25 25"
							fill="none"
							xmlns="http://www.w3.org/2000/svg"
						>
							<circle
								opacity="0.05"
								cx="12.5"
								cy="12.5"
								r="12.5"
								fill="#3966D0"
							/>
							<path
								d="M13.9893 8.25586L16.6797 10.9463C17.5391 10.0918 17.5732 9.00781 16.748 8.1875C15.9277 7.37695 14.8486 7.39648 13.9893 8.25586ZM13.501 8.74902C12.9834 9.25684 12.7686 9.83789 12.8418 10.3994L8.30566 15.2871C8.12012 15.4873 8.09082 15.7656 8.32031 15.9951L7.69531 16.8008C7.63672 16.8789 7.63184 16.9912 7.71973 17.0791L7.86133 17.2256C7.94434 17.3086 8.05664 17.3135 8.14453 17.2451L8.9502 16.6152C9.16992 16.8447 9.45312 16.8154 9.64844 16.6299L12.1826 14.2861V17.0742C12.1826 17.3232 12.3779 17.5186 12.627 17.5186C12.876 17.5186 13.0713 17.3232 13.0713 17.0742V14.1885L13.0371 13.4902L14.5264 12.1084C15.0879 12.1816 15.6787 11.9521 16.1865 11.4395L13.501 8.74902ZM8.80859 15.6875L13.1104 11.127C13.1934 11.2637 13.2959 11.3955 13.418 11.5225C13.54 11.6445 13.667 11.752 13.7988 11.8398L9.25781 16.1367L8.80859 15.6875Z"
								fill="#3966D0"
							/>
						</svg>
					),
					items: 0,
					increase: 0,
				},
				{
					title: "online",
					icon: (
						<svg
							width="25"
							height="25"
							viewBox="0 0 25 25"
							fill="none"
							xmlns="http://www.w3.org/2000/svg"
						>
							<circle
								opacity="0.05"
								cx="12.5"
								cy="12.5"
								r="12.5"
								fill="#3966D0"
							/>
							<path
								d="M12.5049 17.3232C15.1562 17.3232 17.3486 15.126 17.3486 12.4746C17.3486 9.82812 15.1514 7.62598 12.5 7.62598C9.84863 7.62598 7.65137 9.82812 7.65137 12.4746C7.65137 15.126 9.85352 17.3232 12.5049 17.3232ZM11.0986 9.94531C11.3867 9.21777 11.7871 8.69531 12.2217 8.53418V10.0576C11.8164 10.0479 11.4453 10.0088 11.0986 9.94531ZM12.7832 8.53418C13.2129 8.69531 13.6133 9.21777 13.9014 9.94531C13.5596 10.0088 13.1836 10.0479 12.7832 10.0576V8.53418ZM13.8086 8.6709C14.3311 8.85156 14.8047 9.12988 15.2051 9.49609C14.9854 9.61816 14.7363 9.7207 14.458 9.80859C14.2822 9.35449 14.0625 8.96875 13.8086 8.6709ZM9.79492 9.49609C10.1953 9.13477 10.6689 8.85156 11.1914 8.6709C10.9424 8.96875 10.7178 9.35449 10.542 9.80859C10.2637 9.7207 10.0146 9.61816 9.79492 9.49609ZM14.9219 12.1914C14.8975 11.5127 14.7998 10.8828 14.6338 10.3262C15 10.2139 15.3271 10.0723 15.5957 9.90625C16.1182 10.5312 16.4502 11.3223 16.5088 12.1914H14.9219ZM8.49609 12.1914C8.55469 11.3223 8.88672 10.5312 9.4043 9.90625C9.67773 10.0723 10 10.2139 10.3662 10.3262C10.2051 10.8828 10.1025 11.5127 10.0781 12.1914H8.49609ZM12.7832 12.1914V10.6191C13.2373 10.6045 13.6719 10.5508 14.0771 10.4678C14.2285 10.9902 14.3213 11.5762 14.3457 12.1914H12.7832ZM10.6543 12.1914C10.6787 11.5762 10.7764 10.9902 10.9229 10.4678C11.3281 10.5508 11.7627 10.6045 12.2217 10.6191V12.1914H10.6543ZM8.49121 12.7529H10.0781C10.0977 13.4414 10.2002 14.0859 10.3662 14.6475C10.0049 14.7598 9.6875 14.8965 9.41895 15.0625C8.8916 14.4277 8.55469 13.6318 8.49121 12.7529ZM10.6543 12.7529H12.2217V14.3545C11.7627 14.3691 11.3281 14.418 10.9229 14.5059C10.7715 13.9785 10.6738 13.3779 10.6543 12.7529ZM12.7832 14.3545V12.7529H14.3457C14.3262 13.3779 14.2285 13.9785 14.0771 14.5059C13.6719 14.418 13.2373 14.3691 12.7832 14.3545ZM14.6338 14.6475C14.7998 14.0859 14.9023 13.4414 14.9219 12.7529H16.5137C16.4551 13.6318 16.1182 14.4326 15.5908 15.0625C15.3174 14.9014 14.9951 14.7598 14.6338 14.6475ZM11.0986 15.0283C11.4453 14.9648 11.8164 14.9258 12.2217 14.916V16.4395C11.7871 16.2783 11.3867 15.7559 11.0986 15.0283ZM12.7832 14.916C13.1836 14.9258 13.5596 14.9648 13.9014 15.0283C13.6133 15.7559 13.2129 16.2783 12.7832 16.4395V14.916ZM9.81445 15.4678C10.0293 15.3506 10.2686 15.248 10.542 15.165C10.7129 15.6045 10.9277 15.9756 11.167 16.2734C10.6592 16.0977 10.2002 15.8193 9.81445 15.4678ZM14.458 15.165C14.7314 15.248 14.9756 15.3506 15.1953 15.4727C14.7998 15.8242 14.3408 16.1025 13.8281 16.2783C14.0723 15.9805 14.2871 15.6045 14.458 15.165Z"
								fill="#3966D0"
							/>
						</svg>
					),
					items: 0,
					increase: 0,
				},
				{
					title: "newspaper",
					icon: (
						<svg
							width="25"
							height="25"
							viewBox="0 0 25 25"
							fill="none"
							xmlns="http://www.w3.org/2000/svg"
						>
							<circle
								opacity="0.05"
								cx="12.5"
								cy="12.5"
								r="12.5"
								fill="#3966D0"
							/>
							<path
								d="M9.90723 17.7139H15.0928C16.1035 17.7139 16.6064 17.2061 16.6064 16.1855V8.77832C16.6064 7.7627 16.1035 7.24512 15.0928 7.24512H9.90723C8.90137 7.24512 8.39355 7.7627 8.39355 8.77832V16.1855C8.39355 17.2061 8.89648 17.7139 9.90723 17.7139ZM9.94141 16.9277C9.43848 16.9277 9.17969 16.6592 9.17969 16.1709V8.79297C9.17969 8.30957 9.43848 8.03125 9.94629 8.03125H15.0537C15.5615 8.03125 15.8203 8.30469 15.8203 8.79297V16.1709C15.8203 16.6592 15.5615 16.9277 15.0586 16.9277H9.94141ZM10.6494 10.0723H14.3555C14.5264 10.0723 14.6533 9.93555 14.6533 9.76465C14.6533 9.59863 14.5264 9.47168 14.3555 9.47168H10.6494C10.4736 9.47168 10.3467 9.59863 10.3467 9.76465C10.3467 9.93555 10.4736 10.0723 10.6494 10.0723ZM10.6494 11.7764H14.3555C14.5264 11.7764 14.6533 11.6396 14.6533 11.4688C14.6533 11.3027 14.5264 11.1758 14.3555 11.1758H10.6494C10.4736 11.1758 10.3467 11.3027 10.3467 11.4688C10.3467 11.6396 10.4736 11.7764 10.6494 11.7764ZM10.6494 13.4805H12.4023C12.5781 13.4805 12.7051 13.3486 12.7051 13.1826C12.7051 13.0117 12.5781 12.8799 12.4023 12.8799H10.6494C10.4736 12.8799 10.3467 13.0117 10.3467 13.1826C10.3467 13.3486 10.4736 13.4805 10.6494 13.4805Z"
								fill="#3966D0"
							/>
						</svg>
					),
					items: 0,
					increase: 0,
				},
				{
					title: "magazine",
					icon: (
						<svg
							width="25"
							height="25"
							viewBox="0 0 25 25"
							fill="none"
							xmlns="http://www.w3.org/2000/svg"
						>
							<circle
								opacity="0.05"
								cx="12.5"
								cy="12.5"
								r="12.5"
								fill="#3966D0"
							/>
							<path
								d="M12.4951 9.03711C12.124 8.56836 11.2012 8.15332 10.1709 8.15332C8.81836 8.15332 7.72461 8.85156 7.45605 9.50586V16.3271C7.45605 16.6982 7.69531 16.8398 7.96387 16.8398C8.17383 16.8398 8.30078 16.7764 8.43262 16.6738C8.71094 16.4346 9.27246 16.1123 10.1709 16.1123C11.0742 16.1123 11.7041 16.4248 11.9482 16.6445C12.0752 16.7471 12.2266 16.8398 12.4951 16.8398C12.7637 16.8398 12.915 16.7373 13.042 16.6445C13.3057 16.4395 13.9209 16.1123 14.8193 16.1123C15.7227 16.1123 16.2842 16.4395 16.5625 16.6738C16.6943 16.7764 16.8164 16.8398 17.0264 16.8398C17.2949 16.8398 17.5391 16.6982 17.5391 16.3271V9.50586C17.2705 8.85156 16.1719 8.15332 14.8193 8.15332C13.7939 8.15332 12.8711 8.56836 12.4951 9.03711ZM8.24219 9.74023C8.35449 9.4375 9.0625 8.89062 10.1709 8.89062C11.2842 8.89062 12.0068 9.44238 12.1045 9.74023V15.917C11.6406 15.5703 10.9326 15.375 10.1709 15.375C9.41406 15.375 8.70605 15.5703 8.24219 15.9365V9.74023ZM16.7529 9.74023V15.9365C16.2842 15.5703 15.5811 15.375 14.8193 15.375C14.0576 15.375 13.3545 15.5703 12.8906 15.917V9.74023C12.9883 9.44238 13.7109 8.89062 14.8193 8.89062C15.9326 8.89062 16.6406 9.4375 16.7529 9.74023Z"
								fill="#3966D0"
							/>
						</svg>
					),
					items: 0,
					increase: 0,
				},
				{
					title: "print",
					icon: (
						<svg
							width="25"
							height="25"
							viewBox="0 0 25 25"
							fill="none"
							xmlns="http://www.w3.org/2000/svg"
						>
							<circle
								opacity="0.05"
								cx="12.5"
								cy="12.5"
								r="12.5"
								fill="#3966D0"
							/>
							<path
								d="M12.4951 9.03711C12.124 8.56836 11.2012 8.15332 10.1709 8.15332C8.81836 8.15332 7.72461 8.85156 7.45605 9.50586V16.3271C7.45605 16.6982 7.69531 16.8398 7.96387 16.8398C8.17383 16.8398 8.30078 16.7764 8.43262 16.6738C8.71094 16.4346 9.27246 16.1123 10.1709 16.1123C11.0742 16.1123 11.7041 16.4248 11.9482 16.6445C12.0752 16.7471 12.2266 16.8398 12.4951 16.8398C12.7637 16.8398 12.915 16.7373 13.042 16.6445C13.3057 16.4395 13.9209 16.1123 14.8193 16.1123C15.7227 16.1123 16.2842 16.4395 16.5625 16.6738C16.6943 16.7764 16.8164 16.8398 17.0264 16.8398C17.2949 16.8398 17.5391 16.6982 17.5391 16.3271V9.50586C17.2705 8.85156 16.1719 8.15332 14.8193 8.15332C13.7939 8.15332 12.8711 8.56836 12.4951 9.03711ZM8.24219 9.74023C8.35449 9.4375 9.0625 8.89062 10.1709 8.89062C11.2842 8.89062 12.0068 9.44238 12.1045 9.74023V15.917C11.6406 15.5703 10.9326 15.375 10.1709 15.375C9.41406 15.375 8.70605 15.5703 8.24219 15.9365V9.74023ZM16.7529 9.74023V15.9365C16.2842 15.5703 15.5811 15.375 14.8193 15.375C14.0576 15.375 13.3545 15.5703 12.8906 15.917V9.74023C12.9883 9.44238 13.7109 8.89062 14.8193 8.89062C15.9326 8.89062 16.6406 9.4375 16.7529 9.74023Z"
								fill="#3966D0"
							/>
						</svg>
					),
					items: 0,
					increase: 0,
				},
				{
					title: "outdoor",
					icon: (
						<svg
							width="25"
							height="25"
							viewBox="0 0 25 25"
							fill="none"
							xmlns="http://www.w3.org/2000/svg"
						>
							<circle
								opacity="0.05"
								cx="12.5"
								cy="12.5"
								r="12.5"
								fill="#3966D0"
							/>
							<path
								d="M14.1113 17.3916C14.2822 17.3916 14.4531 17.3477 14.5996 17.2646L17.1533 15.8145C17.4463 15.6533 17.5781 15.4189 17.5781 15.0918V8.31934C17.5781 7.95801 17.3779 7.75781 17.0264 7.75781C16.9043 7.75781 16.7773 7.79688 16.6162 7.88477L14.0283 9.3252L11.377 7.69922C11.2256 7.61133 11.0547 7.5625 10.8838 7.5625C10.708 7.5625 10.5322 7.61133 10.3809 7.69922L7.8418 9.14453C7.55371 9.31055 7.42188 9.54492 7.42188 9.87207V16.6348C7.42188 16.9961 7.62207 17.2012 7.97363 17.2012C8.0957 17.2012 8.22266 17.1572 8.37891 17.0693L10.8643 15.7314L13.5645 17.2451C13.7402 17.3428 13.9307 17.3916 14.1113 17.3916ZM8.27148 16.1904C8.23242 16.1904 8.20801 16.1611 8.20801 16.1123V10.0625C8.20801 9.94531 8.25195 9.8623 8.36914 9.79395L10.3711 8.62207C10.4346 8.58789 10.4883 8.55859 10.5469 8.52441V14.9551L8.34473 16.166C8.32031 16.1758 8.2959 16.1904 8.27148 16.1904ZM13.667 16.3418C13.5986 16.3027 13.5254 16.2686 13.4521 16.2295L11.333 15.0332V8.62695C11.3818 8.65625 11.4404 8.68555 11.4893 8.71484L13.667 10.043V16.3418ZM14.4531 16.4297V9.99414L16.6553 8.79297C16.6797 8.77832 16.7041 8.76855 16.7236 8.76855C16.7676 8.76855 16.792 8.79785 16.792 8.84668V14.8965C16.792 15.0186 16.7432 15.1016 16.6309 15.1699L14.6729 16.3076C14.5996 16.3516 14.5264 16.3955 14.4531 16.4297Z"
								fill="#3966D0"
							/>
						</svg>
					),
					items: 0,
					increase: 0,
				},
				{
					title: "mobile",
					icon: (
						<svg
							width="25"
							height="25"
							viewBox="0 0 25 25"
							fill="none"
							xmlns="http://www.w3.org/2000/svg"
						>
							<circle
								opacity="0.05"
								cx="12.5"
								cy="12.5"
								r="12.5"
								fill="#3966D0"
							/>
							<path
								d="M14.1113 17.3916C14.2822 17.3916 14.4531 17.3477 14.5996 17.2646L17.1533 15.8145C17.4463 15.6533 17.5781 15.4189 17.5781 15.0918V8.31934C17.5781 7.95801 17.3779 7.75781 17.0264 7.75781C16.9043 7.75781 16.7773 7.79688 16.6162 7.88477L14.0283 9.3252L11.377 7.69922C11.2256 7.61133 11.0547 7.5625 10.8838 7.5625C10.708 7.5625 10.5322 7.61133 10.3809 7.69922L7.8418 9.14453C7.55371 9.31055 7.42188 9.54492 7.42188 9.87207V16.6348C7.42188 16.9961 7.62207 17.2012 7.97363 17.2012C8.0957 17.2012 8.22266 17.1572 8.37891 17.0693L10.8643 15.7314L13.5645 17.2451C13.7402 17.3428 13.9307 17.3916 14.1113 17.3916ZM8.27148 16.1904C8.23242 16.1904 8.20801 16.1611 8.20801 16.1123V10.0625C8.20801 9.94531 8.25195 9.8623 8.36914 9.79395L10.3711 8.62207C10.4346 8.58789 10.4883 8.55859 10.5469 8.52441V14.9551L8.34473 16.166C8.32031 16.1758 8.2959 16.1904 8.27148 16.1904ZM13.667 16.3418C13.5986 16.3027 13.5254 16.2686 13.4521 16.2295L11.333 15.0332V8.62695C11.3818 8.65625 11.4404 8.68555 11.4893 8.71484L13.667 10.043V16.3418ZM14.4531 16.4297V9.99414L16.6553 8.79297C16.6797 8.77832 16.7041 8.76855 16.7236 8.76855C16.7676 8.76855 16.792 8.79785 16.792 8.84668V14.8965C16.792 15.0186 16.7432 15.1016 16.6309 15.1699L14.6729 16.3076C14.5996 16.3516 14.5264 16.3955 14.4531 16.4297Z"
								fill="#3966D0"
							/>
						</svg>
					),
					items: 0,
					increase: 0,
				},
				{
					title: "podcast",
					icon: (
						<svg
							width="25"
							height="25"
							viewBox="0 0 25 25"
							fill="none"
							xmlns="http://www.w3.org/2000/svg"
						>
							<circle
								opacity="0.05"
								cx="12.5"
								cy="12.5"
								r="12.5"
								fill="#3966D0"
							/>
							<path
								d="M14.1113 17.3916C14.2822 17.3916 14.4531 17.3477 14.5996 17.2646L17.1533 15.8145C17.4463 15.6533 17.5781 15.4189 17.5781 15.0918V8.31934C17.5781 7.95801 17.3779 7.75781 17.0264 7.75781C16.9043 7.75781 16.7773 7.79688 16.6162 7.88477L14.0283 9.3252L11.377 7.69922C11.2256 7.61133 11.0547 7.5625 10.8838 7.5625C10.708 7.5625 10.5322 7.61133 10.3809 7.69922L7.8418 9.14453C7.55371 9.31055 7.42188 9.54492 7.42188 9.87207V16.6348C7.42188 16.9961 7.62207 17.2012 7.97363 17.2012C8.0957 17.2012 8.22266 17.1572 8.37891 17.0693L10.8643 15.7314L13.5645 17.2451C13.7402 17.3428 13.9307 17.3916 14.1113 17.3916ZM8.27148 16.1904C8.23242 16.1904 8.20801 16.1611 8.20801 16.1123V10.0625C8.20801 9.94531 8.25195 9.8623 8.36914 9.79395L10.3711 8.62207C10.4346 8.58789 10.4883 8.55859 10.5469 8.52441V14.9551L8.34473 16.166C8.32031 16.1758 8.2959 16.1904 8.27148 16.1904ZM13.667 16.3418C13.5986 16.3027 13.5254 16.2686 13.4521 16.2295L11.333 15.0332V8.62695C11.3818 8.65625 11.4404 8.68555 11.4893 8.71484L13.667 10.043V16.3418ZM14.4531 16.4297V9.99414L16.6553 8.79297C16.6797 8.77832 16.7041 8.76855 16.7236 8.76855C16.7676 8.76855 16.792 8.79785 16.792 8.84668V14.8965C16.792 15.0186 16.7432 15.1016 16.6309 15.1699L14.6729 16.3076C14.5996 16.3516 14.5264 16.3955 14.4531 16.4297Z"
								fill="#3966D0"
							/>
						</svg>
					),
					items: 0,
					increase: 0,
				},
				{
					title: "direct marketing",
					icon: (
						<svg
							width="25"
							height="25"
							viewBox="0 0 25 25"
							fill="none"
							xmlns="http://www.w3.org/2000/svg"
						>
							<circle
								opacity="0.05"
								cx="12.5"
								cy="12.5"
								r="12.5"
								fill="#3966D0"
							/>
							<path
								d="M14.1113 17.3916C14.2822 17.3916 14.4531 17.3477 14.5996 17.2646L17.1533 15.8145C17.4463 15.6533 17.5781 15.4189 17.5781 15.0918V8.31934C17.5781 7.95801 17.3779 7.75781 17.0264 7.75781C16.9043 7.75781 16.7773 7.79688 16.6162 7.88477L14.0283 9.3252L11.377 7.69922C11.2256 7.61133 11.0547 7.5625 10.8838 7.5625C10.708 7.5625 10.5322 7.61133 10.3809 7.69922L7.8418 9.14453C7.55371 9.31055 7.42188 9.54492 7.42188 9.87207V16.6348C7.42188 16.9961 7.62207 17.2012 7.97363 17.2012C8.0957 17.2012 8.22266 17.1572 8.37891 17.0693L10.8643 15.7314L13.5645 17.2451C13.7402 17.3428 13.9307 17.3916 14.1113 17.3916ZM8.27148 16.1904C8.23242 16.1904 8.20801 16.1611 8.20801 16.1123V10.0625C8.20801 9.94531 8.25195 9.8623 8.36914 9.79395L10.3711 8.62207C10.4346 8.58789 10.4883 8.55859 10.5469 8.52441V14.9551L8.34473 16.166C8.32031 16.1758 8.2959 16.1904 8.27148 16.1904ZM13.667 16.3418C13.5986 16.3027 13.5254 16.2686 13.4521 16.2295L11.333 15.0332V8.62695C11.3818 8.65625 11.4404 8.68555 11.4893 8.71484L13.667 10.043V16.3418ZM14.4531 16.4297V9.99414L16.6553 8.79297C16.6797 8.77832 16.7041 8.76855 16.7236 8.76855C16.7676 8.76855 16.792 8.79785 16.792 8.84668V14.8965C16.792 15.0186 16.7432 15.1016 16.6309 15.1699L14.6729 16.3076C14.5996 16.3516 14.5264 16.3955 14.4531 16.4297Z"
								fill="#3966D0"
							/>
						</svg>
					),
					items: 0,
					increase: 0,
				},
				{
					title: "social media",
					icon: (
						<svg
							width="25"
							height="25"
							viewBox="0 0 25 25"
							fill="none"
							xmlns="http://www.w3.org/2000/svg"
						>
							<circle
								opacity="0.05"
								cx="12.5"
								cy="12.5"
								r="12.5"
								fill="#3966D0"
							/>
							<path
								d="M14.1113 17.3916C14.2822 17.3916 14.4531 17.3477 14.5996 17.2646L17.1533 15.8145C17.4463 15.6533 17.5781 15.4189 17.5781 15.0918V8.31934C17.5781 7.95801 17.3779 7.75781 17.0264 7.75781C16.9043 7.75781 16.7773 7.79688 16.6162 7.88477L14.0283 9.3252L11.377 7.69922C11.2256 7.61133 11.0547 7.5625 10.8838 7.5625C10.708 7.5625 10.5322 7.61133 10.3809 7.69922L7.8418 9.14453C7.55371 9.31055 7.42188 9.54492 7.42188 9.87207V16.6348C7.42188 16.9961 7.62207 17.2012 7.97363 17.2012C8.0957 17.2012 8.22266 17.1572 8.37891 17.0693L10.8643 15.7314L13.5645 17.2451C13.7402 17.3428 13.9307 17.3916 14.1113 17.3916ZM8.27148 16.1904C8.23242 16.1904 8.20801 16.1611 8.20801 16.1123V10.0625C8.20801 9.94531 8.25195 9.8623 8.36914 9.79395L10.3711 8.62207C10.4346 8.58789 10.4883 8.55859 10.5469 8.52441V14.9551L8.34473 16.166C8.32031 16.1758 8.2959 16.1904 8.27148 16.1904ZM13.667 16.3418C13.5986 16.3027 13.5254 16.2686 13.4521 16.2295L11.333 15.0332V8.62695C11.3818 8.65625 11.4404 8.68555 11.4893 8.71484L13.667 10.043V16.3418ZM14.4531 16.4297V9.99414L16.6553 8.79297C16.6797 8.77832 16.7041 8.76855 16.7236 8.76855C16.7676 8.76855 16.792 8.79785 16.792 8.84668V14.8965C16.792 15.0186 16.7432 15.1016 16.6309 15.1699L14.6729 16.3076C14.5996 16.3516 14.5264 16.3955 14.4531 16.4297Z"
								fill="#3966D0"
							/>
						</svg>
					),
					items: 0,
					increase: 0,
				},
			]);
		} else {
			setFilters([
				{
					title: "television",
					icon: (
						<svg
							width="25"
							height="25"
							viewBox="0 0 25 25"
							fill="none"
							xmlns="http://www.w3.org/2000/svg"
						>
							<circle
								opacity="0.05"
								cx="12.5"
								cy="12.5"
								r="12.5"
								fill="#3966D0"
							/>
							<path
								d="M7.30957 15.6533H17.6855C18.5205 15.6533 18.9404 15.2529 18.9404 14.3984V8.80273C18.9404 7.94824 18.5205 7.54785 17.6855 7.54785H7.30957C6.47461 7.54785 6.05469 7.94824 6.05469 8.80273V14.3984C6.05469 15.2529 6.47461 15.6533 7.30957 15.6533ZM7.32422 14.8672C6.9873 14.8672 6.84082 14.7305 6.84082 14.3887V8.81738C6.84082 8.4707 6.9873 8.33398 7.32422 8.33398H17.6709C18.0078 8.33398 18.1543 8.4707 18.1543 8.81738V14.3887C18.1543 14.7305 18.0078 14.8672 17.6709 14.8672H7.32422ZM16.0449 17.0107C16.0449 16.7568 15.8447 16.5518 15.5957 16.5518H9.38965C9.14062 16.5518 8.93555 16.7568 8.93555 17.0107C8.93555 17.2646 9.14062 17.4697 9.38965 17.4697H15.5957C15.8447 17.4697 16.0449 17.2646 16.0449 17.0107Z"
								fill="#3966D0"
							/>
						</svg>
					),
					items: 0,
					increase: 0,
				},
				{
					title: "radio",
					icon: (
						<svg
							width="25"
							height="25"
							viewBox="0 0 25 25"
							fill="none"
							xmlns="http://www.w3.org/2000/svg"
						>
							<circle
								opacity="0.05"
								cx="12.5"
								cy="12.5"
								r="12.5"
								fill="#3966D0"
							/>
							<path
								d="M13.9893 8.25586L16.6797 10.9463C17.5391 10.0918 17.5732 9.00781 16.748 8.1875C15.9277 7.37695 14.8486 7.39648 13.9893 8.25586ZM13.501 8.74902C12.9834 9.25684 12.7686 9.83789 12.8418 10.3994L8.30566 15.2871C8.12012 15.4873 8.09082 15.7656 8.32031 15.9951L7.69531 16.8008C7.63672 16.8789 7.63184 16.9912 7.71973 17.0791L7.86133 17.2256C7.94434 17.3086 8.05664 17.3135 8.14453 17.2451L8.9502 16.6152C9.16992 16.8447 9.45312 16.8154 9.64844 16.6299L12.1826 14.2861V17.0742C12.1826 17.3232 12.3779 17.5186 12.627 17.5186C12.876 17.5186 13.0713 17.3232 13.0713 17.0742V14.1885L13.0371 13.4902L14.5264 12.1084C15.0879 12.1816 15.6787 11.9521 16.1865 11.4395L13.501 8.74902ZM8.80859 15.6875L13.1104 11.127C13.1934 11.2637 13.2959 11.3955 13.418 11.5225C13.54 11.6445 13.667 11.752 13.7988 11.8398L9.25781 16.1367L8.80859 15.6875Z"
								fill="#3966D0"
							/>
						</svg>
					),
					items: 0,
					increase: 0,
				},
				{
					title: "online",
					icon: (
						<svg
							width="25"
							height="25"
							viewBox="0 0 25 25"
							fill="none"
							xmlns="http://www.w3.org/2000/svg"
						>
							<circle
								opacity="0.05"
								cx="12.5"
								cy="12.5"
								r="12.5"
								fill="#3966D0"
							/>
							<path
								d="M12.5049 17.3232C15.1562 17.3232 17.3486 15.126 17.3486 12.4746C17.3486 9.82812 15.1514 7.62598 12.5 7.62598C9.84863 7.62598 7.65137 9.82812 7.65137 12.4746C7.65137 15.126 9.85352 17.3232 12.5049 17.3232ZM11.0986 9.94531C11.3867 9.21777 11.7871 8.69531 12.2217 8.53418V10.0576C11.8164 10.0479 11.4453 10.0088 11.0986 9.94531ZM12.7832 8.53418C13.2129 8.69531 13.6133 9.21777 13.9014 9.94531C13.5596 10.0088 13.1836 10.0479 12.7832 10.0576V8.53418ZM13.8086 8.6709C14.3311 8.85156 14.8047 9.12988 15.2051 9.49609C14.9854 9.61816 14.7363 9.7207 14.458 9.80859C14.2822 9.35449 14.0625 8.96875 13.8086 8.6709ZM9.79492 9.49609C10.1953 9.13477 10.6689 8.85156 11.1914 8.6709C10.9424 8.96875 10.7178 9.35449 10.542 9.80859C10.2637 9.7207 10.0146 9.61816 9.79492 9.49609ZM14.9219 12.1914C14.8975 11.5127 14.7998 10.8828 14.6338 10.3262C15 10.2139 15.3271 10.0723 15.5957 9.90625C16.1182 10.5312 16.4502 11.3223 16.5088 12.1914H14.9219ZM8.49609 12.1914C8.55469 11.3223 8.88672 10.5312 9.4043 9.90625C9.67773 10.0723 10 10.2139 10.3662 10.3262C10.2051 10.8828 10.1025 11.5127 10.0781 12.1914H8.49609ZM12.7832 12.1914V10.6191C13.2373 10.6045 13.6719 10.5508 14.0771 10.4678C14.2285 10.9902 14.3213 11.5762 14.3457 12.1914H12.7832ZM10.6543 12.1914C10.6787 11.5762 10.7764 10.9902 10.9229 10.4678C11.3281 10.5508 11.7627 10.6045 12.2217 10.6191V12.1914H10.6543ZM8.49121 12.7529H10.0781C10.0977 13.4414 10.2002 14.0859 10.3662 14.6475C10.0049 14.7598 9.6875 14.8965 9.41895 15.0625C8.8916 14.4277 8.55469 13.6318 8.49121 12.7529ZM10.6543 12.7529H12.2217V14.3545C11.7627 14.3691 11.3281 14.418 10.9229 14.5059C10.7715 13.9785 10.6738 13.3779 10.6543 12.7529ZM12.7832 14.3545V12.7529H14.3457C14.3262 13.3779 14.2285 13.9785 14.0771 14.5059C13.6719 14.418 13.2373 14.3691 12.7832 14.3545ZM14.6338 14.6475C14.7998 14.0859 14.9023 13.4414 14.9219 12.7529H16.5137C16.4551 13.6318 16.1182 14.4326 15.5908 15.0625C15.3174 14.9014 14.9951 14.7598 14.6338 14.6475ZM11.0986 15.0283C11.4453 14.9648 11.8164 14.9258 12.2217 14.916V16.4395C11.7871 16.2783 11.3867 15.7559 11.0986 15.0283ZM12.7832 14.916C13.1836 14.9258 13.5596 14.9648 13.9014 15.0283C13.6133 15.7559 13.2129 16.2783 12.7832 16.4395V14.916ZM9.81445 15.4678C10.0293 15.3506 10.2686 15.248 10.542 15.165C10.7129 15.6045 10.9277 15.9756 11.167 16.2734C10.6592 16.0977 10.2002 15.8193 9.81445 15.4678ZM14.458 15.165C14.7314 15.248 14.9756 15.3506 15.1953 15.4727C14.7998 15.8242 14.3408 16.1025 13.8281 16.2783C14.0723 15.9805 14.2871 15.6045 14.458 15.165Z"
								fill="#3966D0"
							/>
						</svg>
					),
					items: 0,
					increase: 0,
				},
				{
					title: "newspaper",
					icon: (
						<svg
							width="25"
							height="25"
							viewBox="0 0 25 25"
							fill="none"
							xmlns="http://www.w3.org/2000/svg"
						>
							<circle
								opacity="0.05"
								cx="12.5"
								cy="12.5"
								r="12.5"
								fill="#3966D0"
							/>
							<path
								d="M9.90723 17.7139H15.0928C16.1035 17.7139 16.6064 17.2061 16.6064 16.1855V8.77832C16.6064 7.7627 16.1035 7.24512 15.0928 7.24512H9.90723C8.90137 7.24512 8.39355 7.7627 8.39355 8.77832V16.1855C8.39355 17.2061 8.89648 17.7139 9.90723 17.7139ZM9.94141 16.9277C9.43848 16.9277 9.17969 16.6592 9.17969 16.1709V8.79297C9.17969 8.30957 9.43848 8.03125 9.94629 8.03125H15.0537C15.5615 8.03125 15.8203 8.30469 15.8203 8.79297V16.1709C15.8203 16.6592 15.5615 16.9277 15.0586 16.9277H9.94141ZM10.6494 10.0723H14.3555C14.5264 10.0723 14.6533 9.93555 14.6533 9.76465C14.6533 9.59863 14.5264 9.47168 14.3555 9.47168H10.6494C10.4736 9.47168 10.3467 9.59863 10.3467 9.76465C10.3467 9.93555 10.4736 10.0723 10.6494 10.0723ZM10.6494 11.7764H14.3555C14.5264 11.7764 14.6533 11.6396 14.6533 11.4688C14.6533 11.3027 14.5264 11.1758 14.3555 11.1758H10.6494C10.4736 11.1758 10.3467 11.3027 10.3467 11.4688C10.3467 11.6396 10.4736 11.7764 10.6494 11.7764ZM10.6494 13.4805H12.4023C12.5781 13.4805 12.7051 13.3486 12.7051 13.1826C12.7051 13.0117 12.5781 12.8799 12.4023 12.8799H10.6494C10.4736 12.8799 10.3467 13.0117 10.3467 13.1826C10.3467 13.3486 10.4736 13.4805 10.6494 13.4805Z"
								fill="#3966D0"
							/>
						</svg>
					),
					items: 0,
					increase: 0,
				},
				{
					title: "magazine",
					icon: (
						<svg
							width="25"
							height="25"
							viewBox="0 0 25 25"
							fill="none"
							xmlns="http://www.w3.org/2000/svg"
						>
							<circle
								opacity="0.05"
								cx="12.5"
								cy="12.5"
								r="12.5"
								fill="#3966D0"
							/>
							<path
								d="M12.4951 9.03711C12.124 8.56836 11.2012 8.15332 10.1709 8.15332C8.81836 8.15332 7.72461 8.85156 7.45605 9.50586V16.3271C7.45605 16.6982 7.69531 16.8398 7.96387 16.8398C8.17383 16.8398 8.30078 16.7764 8.43262 16.6738C8.71094 16.4346 9.27246 16.1123 10.1709 16.1123C11.0742 16.1123 11.7041 16.4248 11.9482 16.6445C12.0752 16.7471 12.2266 16.8398 12.4951 16.8398C12.7637 16.8398 12.915 16.7373 13.042 16.6445C13.3057 16.4395 13.9209 16.1123 14.8193 16.1123C15.7227 16.1123 16.2842 16.4395 16.5625 16.6738C16.6943 16.7764 16.8164 16.8398 17.0264 16.8398C17.2949 16.8398 17.5391 16.6982 17.5391 16.3271V9.50586C17.2705 8.85156 16.1719 8.15332 14.8193 8.15332C13.7939 8.15332 12.8711 8.56836 12.4951 9.03711ZM8.24219 9.74023C8.35449 9.4375 9.0625 8.89062 10.1709 8.89062C11.2842 8.89062 12.0068 9.44238 12.1045 9.74023V15.917C11.6406 15.5703 10.9326 15.375 10.1709 15.375C9.41406 15.375 8.70605 15.5703 8.24219 15.9365V9.74023ZM16.7529 9.74023V15.9365C16.2842 15.5703 15.5811 15.375 14.8193 15.375C14.0576 15.375 13.3545 15.5703 12.8906 15.917V9.74023C12.9883 9.44238 13.7109 8.89062 14.8193 8.89062C15.9326 8.89062 16.6406 9.4375 16.7529 9.74023Z"
								fill="#3966D0"
							/>
						</svg>
					),
					items: 0,
					increase: 0,
				},
				{
					title: "print",
					icon: (
						<svg
							width="25"
							height="25"
							viewBox="0 0 25 25"
							fill="none"
							xmlns="http://www.w3.org/2000/svg"
						>
							<circle
								opacity="0.05"
								cx="12.5"
								cy="12.5"
								r="12.5"
								fill="#3966D0"
							/>
							<path
								d="M12.4951 9.03711C12.124 8.56836 11.2012 8.15332 10.1709 8.15332C8.81836 8.15332 7.72461 8.85156 7.45605 9.50586V16.3271C7.45605 16.6982 7.69531 16.8398 7.96387 16.8398C8.17383 16.8398 8.30078 16.7764 8.43262 16.6738C8.71094 16.4346 9.27246 16.1123 10.1709 16.1123C11.0742 16.1123 11.7041 16.4248 11.9482 16.6445C12.0752 16.7471 12.2266 16.8398 12.4951 16.8398C12.7637 16.8398 12.915 16.7373 13.042 16.6445C13.3057 16.4395 13.9209 16.1123 14.8193 16.1123C15.7227 16.1123 16.2842 16.4395 16.5625 16.6738C16.6943 16.7764 16.8164 16.8398 17.0264 16.8398C17.2949 16.8398 17.5391 16.6982 17.5391 16.3271V9.50586C17.2705 8.85156 16.1719 8.15332 14.8193 8.15332C13.7939 8.15332 12.8711 8.56836 12.4951 9.03711ZM8.24219 9.74023C8.35449 9.4375 9.0625 8.89062 10.1709 8.89062C11.2842 8.89062 12.0068 9.44238 12.1045 9.74023V15.917C11.6406 15.5703 10.9326 15.375 10.1709 15.375C9.41406 15.375 8.70605 15.5703 8.24219 15.9365V9.74023ZM16.7529 9.74023V15.9365C16.2842 15.5703 15.5811 15.375 14.8193 15.375C14.0576 15.375 13.3545 15.5703 12.8906 15.917V9.74023C12.9883 9.44238 13.7109 8.89062 14.8193 8.89062C15.9326 8.89062 16.6406 9.4375 16.7529 9.74023Z"
								fill="#3966D0"
							/>
						</svg>
					),
					items: 0,
					increase: 0,
				},
				{
					title: "outdoor",
					icon: (
						<svg
							width="25"
							height="25"
							viewBox="0 0 25 25"
							fill="none"
							xmlns="http://www.w3.org/2000/svg"
						>
							<circle
								opacity="0.05"
								cx="12.5"
								cy="12.5"
								r="12.5"
								fill="#3966D0"
							/>
							<path
								d="M14.1113 17.3916C14.2822 17.3916 14.4531 17.3477 14.5996 17.2646L17.1533 15.8145C17.4463 15.6533 17.5781 15.4189 17.5781 15.0918V8.31934C17.5781 7.95801 17.3779 7.75781 17.0264 7.75781C16.9043 7.75781 16.7773 7.79688 16.6162 7.88477L14.0283 9.3252L11.377 7.69922C11.2256 7.61133 11.0547 7.5625 10.8838 7.5625C10.708 7.5625 10.5322 7.61133 10.3809 7.69922L7.8418 9.14453C7.55371 9.31055 7.42188 9.54492 7.42188 9.87207V16.6348C7.42188 16.9961 7.62207 17.2012 7.97363 17.2012C8.0957 17.2012 8.22266 17.1572 8.37891 17.0693L10.8643 15.7314L13.5645 17.2451C13.7402 17.3428 13.9307 17.3916 14.1113 17.3916ZM8.27148 16.1904C8.23242 16.1904 8.20801 16.1611 8.20801 16.1123V10.0625C8.20801 9.94531 8.25195 9.8623 8.36914 9.79395L10.3711 8.62207C10.4346 8.58789 10.4883 8.55859 10.5469 8.52441V14.9551L8.34473 16.166C8.32031 16.1758 8.2959 16.1904 8.27148 16.1904ZM13.667 16.3418C13.5986 16.3027 13.5254 16.2686 13.4521 16.2295L11.333 15.0332V8.62695C11.3818 8.65625 11.4404 8.68555 11.4893 8.71484L13.667 10.043V16.3418ZM14.4531 16.4297V9.99414L16.6553 8.79297C16.6797 8.77832 16.7041 8.76855 16.7236 8.76855C16.7676 8.76855 16.792 8.79785 16.792 8.84668V14.8965C16.792 15.0186 16.7432 15.1016 16.6309 15.1699L14.6729 16.3076C14.5996 16.3516 14.5264 16.3955 14.4531 16.4297Z"
								fill="#3966D0"
							/>
						</svg>
					),
					items: 0,
					increase: 0,
				},
				{
					title: "mobile",
					icon: (
						<svg
							width="25"
							height="25"
							viewBox="0 0 25 25"
							fill="none"
							xmlns="http://www.w3.org/2000/svg"
						>
							<circle
								opacity="0.05"
								cx="12.5"
								cy="12.5"
								r="12.5"
								fill="#3966D0"
							/>
							<path
								d="M14.1113 17.3916C14.2822 17.3916 14.4531 17.3477 14.5996 17.2646L17.1533 15.8145C17.4463 15.6533 17.5781 15.4189 17.5781 15.0918V8.31934C17.5781 7.95801 17.3779 7.75781 17.0264 7.75781C16.9043 7.75781 16.7773 7.79688 16.6162 7.88477L14.0283 9.3252L11.377 7.69922C11.2256 7.61133 11.0547 7.5625 10.8838 7.5625C10.708 7.5625 10.5322 7.61133 10.3809 7.69922L7.8418 9.14453C7.55371 9.31055 7.42188 9.54492 7.42188 9.87207V16.6348C7.42188 16.9961 7.62207 17.2012 7.97363 17.2012C8.0957 17.2012 8.22266 17.1572 8.37891 17.0693L10.8643 15.7314L13.5645 17.2451C13.7402 17.3428 13.9307 17.3916 14.1113 17.3916ZM8.27148 16.1904C8.23242 16.1904 8.20801 16.1611 8.20801 16.1123V10.0625C8.20801 9.94531 8.25195 9.8623 8.36914 9.79395L10.3711 8.62207C10.4346 8.58789 10.4883 8.55859 10.5469 8.52441V14.9551L8.34473 16.166C8.32031 16.1758 8.2959 16.1904 8.27148 16.1904ZM13.667 16.3418C13.5986 16.3027 13.5254 16.2686 13.4521 16.2295L11.333 15.0332V8.62695C11.3818 8.65625 11.4404 8.68555 11.4893 8.71484L13.667 10.043V16.3418ZM14.4531 16.4297V9.99414L16.6553 8.79297C16.6797 8.77832 16.7041 8.76855 16.7236 8.76855C16.7676 8.76855 16.792 8.79785 16.792 8.84668V14.8965C16.792 15.0186 16.7432 15.1016 16.6309 15.1699L14.6729 16.3076C14.5996 16.3516 14.5264 16.3955 14.4531 16.4297Z"
								fill="#3966D0"
							/>
						</svg>
					),
					items: 0,
					increase: 0,
				},
				{
					title: "podcast",
					icon: (
						<svg
							width="25"
							height="25"
							viewBox="0 0 25 25"
							fill="none"
							xmlns="http://www.w3.org/2000/svg"
						>
							<circle
								opacity="0.05"
								cx="12.5"
								cy="12.5"
								r="12.5"
								fill="#3966D0"
							/>
							<path
								d="M14.1113 17.3916C14.2822 17.3916 14.4531 17.3477 14.5996 17.2646L17.1533 15.8145C17.4463 15.6533 17.5781 15.4189 17.5781 15.0918V8.31934C17.5781 7.95801 17.3779 7.75781 17.0264 7.75781C16.9043 7.75781 16.7773 7.79688 16.6162 7.88477L14.0283 9.3252L11.377 7.69922C11.2256 7.61133 11.0547 7.5625 10.8838 7.5625C10.708 7.5625 10.5322 7.61133 10.3809 7.69922L7.8418 9.14453C7.55371 9.31055 7.42188 9.54492 7.42188 9.87207V16.6348C7.42188 16.9961 7.62207 17.2012 7.97363 17.2012C8.0957 17.2012 8.22266 17.1572 8.37891 17.0693L10.8643 15.7314L13.5645 17.2451C13.7402 17.3428 13.9307 17.3916 14.1113 17.3916ZM8.27148 16.1904C8.23242 16.1904 8.20801 16.1611 8.20801 16.1123V10.0625C8.20801 9.94531 8.25195 9.8623 8.36914 9.79395L10.3711 8.62207C10.4346 8.58789 10.4883 8.55859 10.5469 8.52441V14.9551L8.34473 16.166C8.32031 16.1758 8.2959 16.1904 8.27148 16.1904ZM13.667 16.3418C13.5986 16.3027 13.5254 16.2686 13.4521 16.2295L11.333 15.0332V8.62695C11.3818 8.65625 11.4404 8.68555 11.4893 8.71484L13.667 10.043V16.3418ZM14.4531 16.4297V9.99414L16.6553 8.79297C16.6797 8.77832 16.7041 8.76855 16.7236 8.76855C16.7676 8.76855 16.792 8.79785 16.792 8.84668V14.8965C16.792 15.0186 16.7432 15.1016 16.6309 15.1699L14.6729 16.3076C14.5996 16.3516 14.5264 16.3955 14.4531 16.4297Z"
								fill="#3966D0"
							/>
						</svg>
					),
					items: 0,
					increase: 0,
				},
				{
					title: "direct marketing",
					icon: (
						<svg
							width="25"
							height="25"
							viewBox="0 0 25 25"
							fill="none"
							xmlns="http://www.w3.org/2000/svg"
						>
							<circle
								opacity="0.05"
								cx="12.5"
								cy="12.5"
								r="12.5"
								fill="#3966D0"
							/>
							<path
								d="M14.1113 17.3916C14.2822 17.3916 14.4531 17.3477 14.5996 17.2646L17.1533 15.8145C17.4463 15.6533 17.5781 15.4189 17.5781 15.0918V8.31934C17.5781 7.95801 17.3779 7.75781 17.0264 7.75781C16.9043 7.75781 16.7773 7.79688 16.6162 7.88477L14.0283 9.3252L11.377 7.69922C11.2256 7.61133 11.0547 7.5625 10.8838 7.5625C10.708 7.5625 10.5322 7.61133 10.3809 7.69922L7.8418 9.14453C7.55371 9.31055 7.42188 9.54492 7.42188 9.87207V16.6348C7.42188 16.9961 7.62207 17.2012 7.97363 17.2012C8.0957 17.2012 8.22266 17.1572 8.37891 17.0693L10.8643 15.7314L13.5645 17.2451C13.7402 17.3428 13.9307 17.3916 14.1113 17.3916ZM8.27148 16.1904C8.23242 16.1904 8.20801 16.1611 8.20801 16.1123V10.0625C8.20801 9.94531 8.25195 9.8623 8.36914 9.79395L10.3711 8.62207C10.4346 8.58789 10.4883 8.55859 10.5469 8.52441V14.9551L8.34473 16.166C8.32031 16.1758 8.2959 16.1904 8.27148 16.1904ZM13.667 16.3418C13.5986 16.3027 13.5254 16.2686 13.4521 16.2295L11.333 15.0332V8.62695C11.3818 8.65625 11.4404 8.68555 11.4893 8.71484L13.667 10.043V16.3418ZM14.4531 16.4297V9.99414L16.6553 8.79297C16.6797 8.77832 16.7041 8.76855 16.7236 8.76855C16.7676 8.76855 16.792 8.79785 16.792 8.84668V14.8965C16.792 15.0186 16.7432 15.1016 16.6309 15.1699L14.6729 16.3076C14.5996 16.3516 14.5264 16.3955 14.4531 16.4297Z"
								fill="#3966D0"
							/>
						</svg>
					),
					items: 0,
					increase: 0,
				},
				{
					title: "social media",
					icon: (
						<svg
							width="25"
							height="25"
							viewBox="0 0 25 25"
							fill="none"
							xmlns="http://www.w3.org/2000/svg"
						>
							<circle
								opacity="0.05"
								cx="12.5"
								cy="12.5"
								r="12.5"
								fill="#3966D0"
							/>
							<path
								d="M14.1113 17.3916C14.2822 17.3916 14.4531 17.3477 14.5996 17.2646L17.1533 15.8145C17.4463 15.6533 17.5781 15.4189 17.5781 15.0918V8.31934C17.5781 7.95801 17.3779 7.75781 17.0264 7.75781C16.9043 7.75781 16.7773 7.79688 16.6162 7.88477L14.0283 9.3252L11.377 7.69922C11.2256 7.61133 11.0547 7.5625 10.8838 7.5625C10.708 7.5625 10.5322 7.61133 10.3809 7.69922L7.8418 9.14453C7.55371 9.31055 7.42188 9.54492 7.42188 9.87207V16.6348C7.42188 16.9961 7.62207 17.2012 7.97363 17.2012C8.0957 17.2012 8.22266 17.1572 8.37891 17.0693L10.8643 15.7314L13.5645 17.2451C13.7402 17.3428 13.9307 17.3916 14.1113 17.3916ZM8.27148 16.1904C8.23242 16.1904 8.20801 16.1611 8.20801 16.1123V10.0625C8.20801 9.94531 8.25195 9.8623 8.36914 9.79395L10.3711 8.62207C10.4346 8.58789 10.4883 8.55859 10.5469 8.52441V14.9551L8.34473 16.166C8.32031 16.1758 8.2959 16.1904 8.27148 16.1904ZM13.667 16.3418C13.5986 16.3027 13.5254 16.2686 13.4521 16.2295L11.333 15.0332V8.62695C11.3818 8.65625 11.4404 8.68555 11.4893 8.71484L13.667 10.043V16.3418ZM14.4531 16.4297V9.99414L16.6553 8.79297C16.6797 8.77832 16.7041 8.76855 16.7236 8.76855C16.7676 8.76855 16.792 8.79785 16.792 8.84668V14.8965C16.792 15.0186 16.7432 15.1016 16.6309 15.1699L14.6729 16.3076C14.5996 16.3516 14.5264 16.3955 14.4531 16.4297Z"
								fill="#3966D0"
							/>
						</svg>
					),
					items: 0,
					increase: 0,
				},
			]);
		}
	}, [props.route.pathname]);
	React.useEffect(() => {
		emitter.on("chartZoom", (options) => {
			// console.log('EVENT CHART ZOOM: ', options);

			let newMediaTypecounter = {
				television: 0,
				radio: 0,
				online: 0,
				newspaper: 0,
				magazine: 0,
				outdoor: 0,
				mobile: 0,
				podcast: 0,
				directmarketing: 0,
				print: 0,
				advertorial: 0,
			};

			let zoomData;

			switch (options.field) {
				case "appearancedate":
					zoomData = options.valueTab ? props.data?.zoomRateCardDistribution  : props.data?.mediatypeDistribution
					break;
				case "mediatype":
					zoomData = props.data?.mediatypeDistribution
					break;
				case "source":
					zoomData = props.data?.zoomSourceDistribution
					break;
				case "region":
					zoomData = props.data?.zoomRegionDistribution
					break;
				case "category":
					zoomData = props.data?.zoomCategoryDistribution
					break;
				case "language":
					zoomData = props.data?.zoomLanguageDistribution
					break;
				case "brand":
					zoomData = props.data?.zoomBrandDistribution
					break;
				case "topic":
					zoomData = props.data?.zoomTopicDistribution
					break;
				case "advertisingtype":
					zoomData = props.data?.zoomAdvertTypeDistribution
					break;
				case "lsm":
					zoomData = props.data?.zoomLSMDistribution
					break;
				case "author":
					zoomData = props.data?.zoomAuthorDistribution
					break;
				default:
					break;
			}

			if (!zoomData || !Array.isArray(zoomData) || !props.data?.dateRange) {
				return;
			}

			zoomData.forEach((item) => {
				var appDate = moment(new Date(item.appearanceDate)).format('YYYY-MM-DD');
				if (
					(options.values.includes(item[options.field]) || options.values.includes(appDate)) &&
					moment(appDate).valueOf() >=
						moment(
							props.data.dateRange.currentDataDateFrom
						).valueOf() &&
					moment(appDate).valueOf() <=
						moment(props.data.dateRange.currentDataDateTo).valueOf()
				)
					if (options.valueTab)
						newMediaTypecounter[
							item.mediatype.toLowerCase().replace(/\s/g, "")
						] += parseFloat(item.rateCard);
					else
						newMediaTypecounter[
							item.mediatype.toLowerCase().replace(/\s/g, "")
						] += item.count;
			});
			setZoomMediaTypes(newMediaTypecounter);
		});

		emitter.on("chartRestore", () => {
			setZoomMediaTypes(null);
		});

		return () => {
			emitter.off("chartZoom");
			emitter.off("chartRestore");
		};
	}, []); //eslint-disable-line

	React.useEffect(() => {
		// console.log('PROPS LEGEND: ', props);
		pressedItems();
		currentData();
		previousData();
	}, [props.data]); //eslint-disable-line

	// Stable universe of mediatypes the legend manages. Don't tie this to props.data.mediaTypes —
	// that list shrinks after a filter is applied (it reflects only mediatypes present in the
	// filtered response), so indices/lookups against it can't survive a refetch.
	const MEDIATYPE_UNIVERSE = [
		"TELEVISION", "RADIO", "ONLINE", "NEWSPAPER", "MAGAZINE",
		"OUTDOOR", "MOBILE", "PODCAST", "PRINT", "ADVERTORIAL",
		"DIRECT MARKETING", "SOCIAL MEDIA",
	];

	function pressedItems() {
		if (!props.data?.volumeData) return null;

		const stored = JSON.parse(sessionStorage.getItem("filters"))?.mediaType;

		// Convention from changePressedItems: null mediaType filter means "all pressed/excluded".
		if (stored === null) {
			pressed.current = [...MEDIATYPE_UNIVERSE];
			return;
		}
		if (!Array.isArray(stored) || stored.length === 0) {
			pressed.current = [];
			return;
		}

		// stored entries may be names (this component) or indices into props.data.mediaTypes (FormFilters).
		// Resolve to names against the current list. Indices that no longer resolve (because the list
		// shrunk post-filter) are simply dropped — the names already in stored cover what we need.
		const includedNames = new Set();
		stored.forEach((v) => {
			if (typeof v === "string") includedNames.add(v.toUpperCase());
			else if (typeof v === "number" && props.data.mediaTypes?.[v]) {
				includedNames.add(String(props.data.mediaTypes[v]).toUpperCase());
			}
		});

		pressed.current = MEDIATYPE_UNIVERSE.filter((mt) => !includedNames.has(mt));
	}

	function countItems(filter) {
		let counter = 0;
		Object.keys(currentDataTotal).forEach((item) => {
			if (
				item.toLowerCase() === filter.replace(/\s/g, "").toLowerCase()
			) {
				counter += currentDataTotal[item];
			}
		});
		return counter;
	}

	function valueCalc(filter) {
		let value = 0;
		if (props.data.zoomRateCardDistribution)
			props.data.zoomRateCardDistribution.forEach((item) => {
				var appDate = moment(new Date(item.appearanceDate)).format('YYYY-MM-DD');
				if (
					moment(appDate).valueOf() >=
						moment(
							props.data.dateRange.currentDataDateFrom
						).valueOf() &&
					moment(appDate).valueOf() <=
						moment(props.data.dateRange.currentDataDateTo).valueOf()
				)
					if (
						item.mediatype.toLowerCase() === filter &&
						item.rateCard
					)
						value += parseFloat(
							item.rateCard
						);
			});
		return new Intl.NumberFormat("en-US").format(value.toFixed(2));
	}

	function allValue() {
		let value = 0;
		if (props.data.zoomRateCardDistribution)
			props.data.zoomRateCardDistribution.forEach((item) => {
				var appDate = moment(new Date(item.appearanceDate)).format('YYYY-MM-DD');
				if (
					item.rateCard &&
					moment(appDate).valueOf() >=
						moment(
							props.data.dateRange.currentDataDateFrom
						).valueOf() &&
					moment(appDate).valueOf() <=
						moment(props.data.dateRange.currentDataDateTo).valueOf()
				)
					value += parseFloat(
						item.rateCard
					);
			});
		return new Intl.NumberFormat("en-US").format(value.toFixed(2));
	}

	function allRatio() {
		let currentCount = 0;
		let previousCount = 0;

		Object.keys(currentDataTotal).forEach((item) => {
			currentCount += currentDataTotal[item];
		});
		Object.keys(previousDataTotal).forEach((item) => {
			previousCount += previousDataTotal[item];
		});

		return getPercentageChange(previousCount, currentCount);
	}

	function allRatioValue() {
		let currentCount = 0;
		let previousCount = 0;

		Object.keys(itemValue).forEach((item) => {
			currentCount += itemValue[item];
		});
		Object.keys(previousItemValue).forEach((item) => {
			previousCount += previousItemValue[item];
		});

		return getPercentageChange(previousCount, currentCount);
	}

	function changePressedItems(item) {
		const itemUpper = item.toUpperCase();
		// Only buttons the legend itself rendered can be toggled — stops stray clicks from
		// poisoning the filter, while still allowing un-press of a mediatype that's been excluded
		// out of props.data.mediaTypes after the previous refetch.
		if (!MEDIATYPE_UNIVERSE.includes(itemUpper)) return;

		const index = pressed.current.indexOf(itemUpper);
		if (index === -1) pressed.current.push(itemUpper);
		else pressed.current.splice(index, 1);

		if (props.route.pathname === "/volume") {
			setVolumeToggleVersion((version) => version + 1);
			emitter.emit("volumeLegendToggle", itemUpper);
			return;
		}

		const storageFilters = JSON.parse(sessionStorage.getItem("filters"));
		if (pressed.current.length === MEDIATYPE_UNIVERSE.length) {
			const toStore = {
				...storageFilters,
				mediaType: null,
			};
			sessionStorage.setItem("filters", JSON.stringify(toStore));

			emitter.emit("filter", [
				{ field: "mediaType", values: null },
				{
					field: "brand",
					values: storageFilters.brand.map(
						(e) => props.data.brands[e]
					),
				},
				{
					field: "mediaSource",
					values: storageFilters.mediaSource.map(
						(e) => props.data.mediaSources[e].itemName
					),
				},
				{
					field: "category",
					values: storageFilters.category.map(
						(e) => props.data.categories[e]
					),
				},
				{
					field: "subCategory",
					values: storageFilters.subCategory.map(
						(e) => props.data.subcategories[e]
					),
				},
				{
					field: "type",
					values: storageFilters.type.map((e) => props.data.types[e]),
				},
				{
					field: "sentiment",
					values: storageFilters.sentiment.map(
						(e) => props.data.sentimet[e].itemName
					),
				},
				{
					field: "author",
					values: storageFilters.author.map(
						(e) => props.data.authors[e].itemName
					),
				},
				{
					field: "topic",
					values: storageFilters.topic.map(
						(e) => props.data.topics[e]
					),
				},
				{
					field: "advertType",
					values: storageFilters.advertType.map(
						(e) => props.data.advertTypes[e].itemName
					),
				},
				{
					field: "language",
					values: storageFilters.language.map(
						(e) => props.data.languages[e].itemName
					),
				},
				{
					field: "country",
					values: storageFilters.country.map(
						(e) => props.data.countries[e]
					),
				},
				{
					field: "region",
					values: storageFilters.location.map(
						(e) => props.data.locations[e].itemName
					),
				},
				{ field: "description", values: [storageFilters.search] },
			]);

			return;
		}

		// Compute included mediatypes as the universe minus what the user has pressed (excluded).
		// Storing names (not indices into props.data.mediaTypes) so the next pressedItems() reseed
		// survives a refetch even when graphFilters.mediatypes shrinks.
		const filters = MEDIATYPE_UNIVERSE.filter((mt) => !pressed.current.includes(mt));

		const toStore = {
			...storageFilters,
			mediaType: filters,
		};
		sessionStorage.setItem("filters", JSON.stringify(toStore));

		emitter.emit("filter", [
			{ field: "mediaType", values: filters },
			{
				field: "brand",
				values: storageFilters.brand.map((e) => props.data.brands[e]),
			},
			{
				field: "mediaSource",
				values: storageFilters.mediaSource.map(
					(e) => props.data.mediaSources[e].itemName
				),
			},
			{
				field: "category",
				values: storageFilters.category.map(
					(e) => props.data.categories[e]
				),
			},
			{
				field: "subCategory",
				values: storageFilters.subCategory.map(
					(e) => props.data.subcategories[e]
				),
			},
			{
				field: "type",
				values: storageFilters.type.map((e) => props.data.types[e]),
			},
			{
				field: "sentiment",
				values: storageFilters.sentiment.map(
					(e) => props.data.sentimet[e].itemName
				),
			},
			{
				field: "author",
				values: storageFilters.author.map(
					(e) => props.data.authors[e].itemName
				),
			},
			{
				field: "topic",
				values: storageFilters.topic.map((e) => props.data.topics[e]),
			},
			{
				field: "advertType",
				values: storageFilters.advertType.map(
					(e) => props.data.advertTypes[e].itemName
				),
			},
			{
				field: "language",
				values: storageFilters.language.map(
					(e) => props.data.languages[e].itemName
				),
			},
			{
				field: "country",
				values: storageFilters.country.map(
					(e) => props.data.countries[e]
				),
			},
			{
				field: "region",
				values: storageFilters.location.map(
					(e) => props.data.locations[e].itemName
				),
			},
			{ field: "description", values: [storageFilters.search] },
		]);
	}

	function getPercentageChange(oldNumber, newNumber) {
		var decreaseValue = newNumber - oldNumber;
		let value = ((decreaseValue / oldNumber) * 100).toFixed(2);
		if (!value || isNaN(value)) value = 0;
		if (value === "Infinity" || value === Infinity) value = 100;
		return value;
	}

	// Build a fresh per-mediatype accumulator keyed the same way the rest of this component reads it
	// (lowercase, no spaces — e.g. "directmarketing", "socialmedia").
	function emptyMediatypeAccumulator() {
		return {
			television: 0, radio: 0, online: 0, newspaper: 0, magazine: 0,
			outdoor: 0, mobile: 0, podcast: 0, print: 0, advertorial: 0,
			directmarketing: 0, socialmedia: 0,
		};
	}

	function buildGraphArr() {
		return [
			{ mediatype: "ONLINE", count: 0, color: "#F1D085" },
			{ mediatype: "NEWSPAPER", count: 0, color: "#E18884" },
			{ mediatype: "RADIO", count: 0, color: "#ABCE92" },
			{ mediatype: "MAGAZINE", count: 0, color: "#9CC9E0" },
			{ mediatype: "TELEVISION", count: 0, color: "#7486C7" },
			{ mediatype: "OUTDOOR", count: 0, color: "#BA6FE8" },
			{ mediatype: "MOBILE", count: 0, color: "#A8A8A8" },
			{ mediatype: "DIRECT MARKETING", count: 0, color: "red" },
			{ mediatype: "PODCAST", count: 0, color: "yellow" },
			{ mediatype: "PRINT", count: 0, color: "blue" },
			{ mediatype: "ADVERTORIAL", count: 0, color: "green" },
			{ mediatype: "SOCIAL MEDIA", count: 0, color: "darkmagenta" },
		];
	}

	function inRange(appDate, from, to) {
		const ts = moment(appDate).valueOf();
		return ts >= moment(from).valueOf() && ts <= moment(to).valueOf();
	}

	// Counts come from mediatypeDistribution — same source the volume chart uses, so legend totals match.
	// ZAR sums come from zoomRateCardDistribution (the only source carrying rateCard).
	// Both accumulators start fresh each pass; spreading the prior state used to inflate sums on every refilter.
	function currentData() {
		if (!props.data?.mediatypeDistribution || !props.data?.dateRange) return null;

		const graphArr = buildGraphArr();
		props.data.mediatypeDistribution.forEach((item) => {
			const appDate = moment(new Date(item.appearanceDate)).format('YYYY-MM-DD');
			if (!inRange(appDate, props.data.dateRange.currentDataDateFrom, props.data.dateRange.currentDataDateTo)) return;
			const idx = graphArr.findIndex((e) => e.mediatype === item.mediatype);
			if (idx !== -1) graphArr[idx].count += item.count;
		});
		const results = emptyMediatypeAccumulator();
		graphArr.forEach((value) => {
			results[value.mediatype.toLowerCase().replace(/\s/g, "")] = value.count;
		});
		setCurrentDataTotal(results);

		const value = emptyMediatypeAccumulator();
		(props.data.zoomRateCardDistribution || []).forEach((item) => {
			const appDate = moment(new Date(item.appearanceDate)).format('YYYY-MM-DD');
			if (!inRange(appDate, props.data.dateRange.currentDataDateFrom, props.data.dateRange.currentDataDateTo)) return;
			if (!item.rateCard) return;
			const key = item.mediatype.toLowerCase().replace(/\s/g, "");
			if (key in value) value[key] += parseFloat(item.rateCard);
		});
		setItemValue(value);
	}

	function previousData() {
		if (!props.data?.mediatypeDistribution || !props.data?.dateRange) return null;

		const graphArr = buildGraphArr();
		props.data.mediatypeDistribution.forEach((item) => {
			const appDate = moment(new Date(item.appearanceDate)).format('YYYY-MM-DD');
			if (!inRange(appDate, props.data.dateRange.previousDataDateFrom, props.data.dateRange.previousDataDateTo)) return;
			const idx = graphArr.findIndex((e) => e.mediatype === item.mediatype);
			if (idx !== -1) graphArr[idx].count += item.count;
		});
		const results = emptyMediatypeAccumulator();
		graphArr.forEach((value) => {
			results[value.mediatype.toLowerCase().replace(/\s/g, "")] = value.count;
		});
		setPreviousDataTotal(results);

		const value = emptyMediatypeAccumulator();
		(props.data.zoomRateCardDistribution || []).forEach((item) => {
			const appDate = moment(new Date(item.appearanceDate)).format('YYYY-MM-DD');
			if (!inRange(appDate, props.data.dateRange.previousDataDateFrom, props.data.dateRange.previousDataDateTo)) return;
			if (!item.rateCard) return;
			const key = item.mediatype.toLowerCase().replace(/\s/g, "");
			if (key in value) value[key] += parseFloat(item.rateCard);
		});
		setPreviousItemValue(value);
	}

	return (
        <div
			style={{
				display: "flex",
				flex: 1,
				flexDirection: "row",
				alignItems: "center",
				padding: 32,
				paddingBottom: 0,
			}}
		>
            <Box
				display="flex"
				flexDirection="column"
				style={{ width: "10%", padding: 16 }}
			>
				<Typography
					style={{
						fontSize: 14,
						fontFamily: "Poppins",
						fontWeight: 600,
						color: "#263238",
						textTransform: "capitalize",
					}}
				>
					All
				</Typography>
				<Typography
					style={{
						fontSize: 12,
						fontFamily: "Poppins-Medium",
						color: "#3966D0",
						textTransform: "capitalize",
					}}
				>
					{props.route.pathname === "/value"
						? zoomMediaTypes
							? new Intl.NumberFormat("en-US").format(
									Object.values(zoomMediaTypes).reduce(
										(a, b) => a + b
									)
							  ) + " ZAR"
							: allValue() + " ZAR"
						: zoomMediaTypes
						? Object.values(zoomMediaTypes).reduce(
								(a, b) => a + b
						  ) + " Items"
						: Object.values(currentDataTotal).reduce(
								(a, b) => a + b,
								0
						  ) + " Items"}
				</Typography>
				<Box display="flex" direction="row" alignItems="center">
					{allRatio() > 0 ? (
						<>
							<svg
								width="12"
								height="12"
								viewBox="0 0 12 12"
								fill="none"
								xmlns="http://www.w3.org/2000/svg"
							>
								<path
									d="M9.66602 0.828125L2.55859 0.828124C1.32813 0.828124 0.718751 1.4375 0.718751 2.64453L0.71875 9.79883C0.71875 11.0059 1.32813 11.6152 2.55859 11.6152L9.66602 11.6152C10.8906 11.6152 11.5059 11.0117 11.5059 9.79883L11.5059 2.64453C11.5059 1.43164 10.8906 0.828125 9.66602 0.828125ZM5.35352 4.4375C5.74024 4.02734 6.19141 4.02734 6.57813 4.4375L8.98633 6.99805C9.17383 7.19727 9.17383 7.47266 9.00391 7.64844C8.81641 7.8418 8.52344 7.85352 8.3418 7.66016L5.96289 5.14062L3.57813 7.66016C3.4082 7.85351 3.11523 7.8418 2.92773 7.64844C2.75781 7.47266 2.75781 7.19726 2.94531 6.99805L5.35352 4.4375Z"
									fill="#19AC1C"
								/>
							</svg>
							<Typography
								style={{
									fontSize: 12,
									fontFamily: "Poppins",
									color: "#19AC1C",
									marginLeft: 5,
								}}
							>
								{parseFloat(allRatioValue()).toFixed(2)}%
							</Typography>
						</>
					) : (
						<>
							<svg
								width="12"
								height="12"
								viewBox="0 0 12 12"
								fill="none"
								xmlns="http://www.w3.org/2000/svg"
							>
								<path
									opacity="0.6"
									d="M9.66602 11.1719L2.55859 11.1719C1.32813 11.1719 0.718751 10.5625 0.718751 9.35547L0.71875 2.20117C0.71875 0.994142 1.32813 0.384767 2.55859 0.384767L9.66602 0.384766C10.8906 0.384766 11.5059 0.988281 11.5059 2.20117L11.5059 9.35547C11.5059 10.5684 10.8906 11.1719 9.66602 11.1719ZM5.35352 7.5625C5.74024 7.97266 6.19141 7.97266 6.57813 7.5625L8.98633 5.00195C9.17383 4.80273 9.17383 4.52734 9.00391 4.35156C8.81641 4.1582 8.52344 4.14648 8.3418 4.33984L5.96289 6.85938L3.57813 4.33984C3.4082 4.14649 3.11523 4.1582 2.92773 4.35156C2.75781 4.52734 2.75781 4.80274 2.94531 5.00195L5.35352 7.5625Z"
									fill="#2C2C2C"
								/>
							</svg>
							<Typography
								style={{
									fontSize: 12,
									fontFamily: "Poppins",
									color: "#2C2C2C",
									marginLeft: 5,
								}}
							>
								{parseFloat(allRatioValue()).toFixed(2)}%
							</Typography>
						</>
					)}
					{allRatio() > 0 ? (
						<Typography
							style={{
								fontSize: 12,
								fontFamily: "Poppins-Medium",
								textTransform: "capitalize",
								color: "#263238",
								marginLeft: 5,
							}}
						>
							Increase
						</Typography>
					) : (
						<Typography
							style={{
								fontSize: 12,
								fontFamily: "Poppins-Medium",
								textTransform: "capitalize",
								color: "#263238",
								marginLeft: 5,
							}}
						>
							Decrease
						</Typography>
					)}
				</Box>
			</Box>
            {filters.map((f, index) => {
				let itemPressed =
					pressed.current.indexOf(f.title.toUpperCase()) !== -1;
				const isDisabledVolumeType =
					props.route.pathname === "/volume" && itemPressed;
				let clientHasMt;
				if (props.data?.mediaTypes)
					clientHasMt = props.data.mediaTypes.includes(
						f.title.toUpperCase()
					);
				const color = getMediaTypeColor(f.title);
				const currentValue = currentDataTotal[f.title];
				const previousValue = previousDataTotal[f.title];
				let increase = 0;
				if (props.route.pathname === "/value") {
					const cv = itemValue[f.title];
					const pv = previousItemValue[f.title];
					increase = getPercentageChange(pv, cv);
				} else
					increase = getPercentageChange(previousValue, currentValue);
				if (isNaN(increase)) {
					increase = 0;
				}
				return (
                    <Button
						key={"filter" + index.toString()}
						onClick={() => {
							changePressedItems(f.title);
						}}
						style={{
							display: "flex",
							flex: 1,
							textTransform: "none",
							textAlign: "start",
							justifyContent: "flex-start",
							padding: 0,
						}}
					>
                        <Box
							border={1}
							borderColor={"#E5E9F1"}
							style={{ width: "100%", height: 107 }}
						>
							<div
								style={{
									display: "flex",
									width: "100%",
									height: "100%",
									flexDirection: "column",
									padding: 10,
									backgroundColor:
										itemPressed || !clientHasMt
											? "#E5E9F1"
											: "#fff",
								}}
							>
								<div
									style={{
										display: "flex",
										flexDirection: "row",
										justifyContent: "space-between",
									}}
								>
									<div
										style={{
											fontSize: 14,
											fontFamily: "Poppins",
											fontWeight: 600,
											color: "#263238",
											textTransform: "capitalize",
										}}
									>
										{f.title}
									</div>
									{f.icon}
								</div>
								<div
									style={{
										display: "flex",
										flex: 1,
										flexDirection: "column",
										justifyContent: "flex-end",
									}}
								>
									<div
										style={{
											fontSize: 12,
											fontFamily: "Poppins",
											fontWeight: 500,
											color: "#000",
											opacity: 0.4,
											textTransform: "capitalize",
										}}
									>
										{isDisabledVolumeType
											? "0 Items"
											: props.route.pathname === "/value"
											? zoomMediaTypes
												? new Intl.NumberFormat(
														"en-US"
												  ).format(
														zoomMediaTypes[
															f.title.replace(
																/\s/g,
																""
															)
														]
												  ) + " ZAR"
												: valueCalc(f.title) + " ZAR"
											: zoomMediaTypes
											? zoomMediaTypes[
													f.title.replace(/\s/g, "")
											  ] + " Items"
											: countItems(f.title) + " Items"}
									</div>
									<div
										style={{
											display: "flex",
											flexDirection: "row",
											alignItems: "center",
										}}
									>
										{increase > 0 ? (
											<>
												<svg
													width="12"
													height="12"
													viewBox="0 0 12 12"
													fill="none"
													xmlns="http://www.w3.org/2000/svg"
												>
													<path
														d="M9.66602 0.828125L2.55859 0.828124C1.32813 0.828124 0.718751 1.4375 0.718751 2.64453L0.71875 9.79883C0.71875 11.0059 1.32813 11.6152 2.55859 11.6152L9.66602 11.6152C10.8906 11.6152 11.5059 11.0117 11.5059 9.79883L11.5059 2.64453C11.5059 1.43164 10.8906 0.828125 9.66602 0.828125ZM5.35352 4.4375C5.74024 4.02734 6.19141 4.02734 6.57813 4.4375L8.98633 6.99805C9.17383 7.19727 9.17383 7.47266 9.00391 7.64844C8.81641 7.8418 8.52344 7.85352 8.3418 7.66016L5.96289 5.14062L3.57813 7.66016C3.4082 7.85351 3.11523 7.8418 2.92773 7.64844C2.75781 7.47266 2.75781 7.19726 2.94531 6.99805L5.35352 4.4375Z"
														fill="#19AC1C"
													/>
												</svg>
												<Typography
													style={{
														fontSize: 12,
														fontFamily: "Poppins",
														color: "#19AC1C",
														marginLeft: 5,
													}}
												>
													{increase}%
												</Typography>
											</>
										) : (
											<>
												<svg
													width="12"
													height="12"
													viewBox="0 0 12 12"
													fill="none"
													xmlns="http://www.w3.org/2000/svg"
												>
													<path
														opacity="0.6"
														d="M9.66602 11.1719L2.55859 11.1719C1.32813 11.1719 0.718751 10.5625 0.718751 9.35547L0.71875 2.20117C0.71875 0.994142 1.32813 0.384767 2.55859 0.384767L9.66602 0.384766C10.8906 0.384766 11.5059 0.988281 11.5059 2.20117L11.5059 9.35547C11.5059 10.5684 10.8906 11.1719 9.66602 11.1719ZM5.35352 7.5625C5.74024 7.97266 6.19141 7.97266 6.57813 7.5625L8.98633 5.00195C9.17383 4.80273 9.17383 4.52734 9.00391 4.35156C8.81641 4.1582 8.52344 4.14648 8.3418 4.33984L5.96289 6.85938L3.57813 4.33984C3.4082 4.14649 3.11523 4.1582 2.92773 4.35156C2.75781 4.52734 2.75781 4.80274 2.94531 5.00195L5.35352 7.5625Z"
														fill="#2C2C2C"
													/>
												</svg>
												<Typography
													style={{
														fontSize: 12,
														fontFamily: "Poppins",
														color: "#2C2C2C",
														marginLeft: 5,
													}}
												>
													{increase}%
												</Typography>
											</>
										)}
									</div>
								</div>
							</div>
							<Box
								style={{
									display: "flex",
									justifyContent: "flex-end",
									borderRadius: 5,
								}}
							>
								<Box
									style={{
										width: "100%",
										height: 3,
										backgroundColor: color,
										alignSelf: "flex-end",
										marginBottom: 2,
										marginHorizontal: 3,
										borderRadius: 5,
									}}
								/>
							</Box>
						</Box>
                    </Button>
                );
			})}
        </div>
    );
}
